interface FormResponse {
    error?: string;
}
(() => {
    const unsentEl = document.querySelector('.unsent') as HTMLElement;
    const formEl = unsentEl?.querySelector('form') as HTMLFormElement;
    const errorEl = unsentEl?.querySelector('.error') as HTMLElement;
    const errorContentEl = errorEl?.querySelector('.error-content') as HTMLElement;
    const disabledEls = formEl.querySelectorAll('input,textarea,button,select') as NodeListOf<HTMLInputElement>;

    const sentEl = document.querySelector('.sent') as HTMLElement;
    const sentNameEl = sentEl?.querySelector('.name') as HTMLElement;
    const sentEmailEl = sentEl?.querySelector('.email') as HTMLElement;

    interface State {
        sent: boolean;
        sending: boolean;
        error: string;
        name: string;
        email: string;
    }
    let state: State = {
        sent: false,
        sending: false,
        error: '',
        name: '',
        email: '',
    }

    const update = (newState: Partial<State>) => {
        state = { ...state, ...newState };
        sentNameEl.innerText = state.name;
        sentEmailEl.innerText = state.email;
        errorContentEl.innerText = state.error;
        errorEl.style.display = state.error ? 'block' : 'none';
        unsentEl.style.display = state.sent ? 'none' : 'block';
        sentEl.style.display = state.sent ? 'block' : 'none';
        for (const el of disabledEls) {
            el.disabled = state.sending;
        }
    }
    update(state);

    formEl!.addEventListener('submit', e => {
        e.preventDefault();
        const formData = new FormData(formEl);
        update({
            sending: true,
            error: '',
            name: formData.get('name')?.valueOf() as string || '',
            email: state.email = formData.get('email')?.valueOf() as string || ''
        });
        fetch('/api/support/send', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                accept: 'application/json',
            },
            body: JSON.stringify(Object.fromEntries(formData)),
        }).then(response => response.json()).then((response: FormResponse) => {
            if (response.error) {
                update({ error: response.error });
            } else {
                update({ sent: true });
            }
        }).finally(() => {
            update({ sending: false });
        });
    });
})();
